<template>
	<v-row no-gutters>
		<v-col cols="12">
			<v-row class='fill-height' no-gutters>
				<v-col cols='4'>
					<v-row no-gutters>
						<v-col cols='12' class='py-1 text-center'>
							<div class='font-weight-bold text-uppercase text-center indigo--text text--darken-4 text-h3 white--text'>Draw hours</div>
							<div id="draws">
								<span v-for='sortition in generalInformation.sortedSortitions'
											:key='sortition.id'
											class="mx-1" :class='{"red--text": generalInformation.sortition.id === sortition.id, "white--text": generalInformation.sortition.id !== sortition.id }'
								>
										{{ sortition.abbreviation }}
								</span>
							</div>
						</v-col>
						<v-col cols='12'>
							<card-presenter
								:time-per-page="10000">
								<template #page-1>
									<v-img contain width="500px" :src="require('@/assets/img/caribbeanPick/banner.webp')"></v-img>
								</template>
								<template #page-2>
									<v-img width="500px" :src="require('@/assets/img/caribbeanPick/payouts.webp')"></v-img>
								</template>
								<template #page-3>
									<v-card>
										<hot-cold-numbers class="pa-5" :hot-numbers="hotNumbers" :cold-numbers="coldNumbers"></hot-cold-numbers>
									</v-card>
								</template>
							</card-presenter>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='4' class='px-4'>
					<v-row no-gutters>
						<v-col cols='12' class='justify-center'>
							<v-img contain height='210' :src="require('@/assets/img/caribbeanPick/logo.png')"/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols='12' class='text-center'>
							<span id="description">British Virgin Islands</span>
						</v-col>
					</v-row>
					<v-row no-gutters class="py-2">
						<v-col>
							<v-card class='fill-height rounded-md indigo--text text--darken-4'>
								<countdown id="countdown" px-2 py-2 text-center :sortition='generalInformation.sortition'>
									<template #default='{sortition}'>
										<v-flex md3>
											<h3 class='font-weight-bold text-uppercase'>Next draw in</h3>
										</v-flex>
										<v-flex md3>
								<span id='time-left' v-if='sortition.timeLeft'
											class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
											<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
										</v-flex>
									</template>
								</countdown>
							</v-card>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col>
							<v-card class='text-center fill-height rounded-md'>
								<span>
										LAST WINNING PICK
								</span>
								<result-display v-if='generalInformation.results[0]' :result='generalInformation.results[0]'/>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='4'>
					<v-row no-gutters>
						<v-col>
							<current-date-and-time-display class="indigo--text text--darken-4" show-current-day :general-information='generalInformation'/>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<card-presenter
								:time-per-page='[timeToShowResultsPage, timeToShowResultsPage,timeToShowPrizesPage]'>
								<template #page-1>
									<v-row no-gutters>
										<v-col cols='12'>
											<v-card class='rounded-md text-uppercase y-1'>
												<div class='font-weight-bold text-spread text-uppercase text-center text-h5 white--text'>Last Winning</div>
												<complex-result-display
													v-for='result in generalInformation.results.slice(1,4)'
													class="sortition-result"
													:key='result.sortition.id'
													:result='result'
												>
												</complex-result-display>
											</v-card>
										</v-col>
									</v-row>
								</template>
								<template #page-2>
									<v-row no-gutters>
										<v-col cols='12'>
											<v-card class='rounded-md text-uppercase y-1'>
												<div class='font-weight-bold text-spread text-uppercase text-center text-h5 white--text'>Last Winning</div>
												<complex-result-display
													v-for='result in generalInformation.results.slice(4,7)'
													class="sortition-result"
													:key='result.sortition.id'
													:result='result'
												>
												</complex-result-display>
											</v-card>
										</v-col>
									</v-row>
								</template>
								<template #page-3>
									<v-card class='rounded-md'>
										<div class='font-weight-bold text-uppercase text-center text-h4 white--text'>Payouts</div>
										<v-container class="pt-0">
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													1st
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $75
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													2nd
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $15
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													3rd
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $10
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													SINGULATION
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $9
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													BOLITA
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $90
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													PALE
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $2,000
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													TRIPLET
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $20,000
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													PICK 3
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $900
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													PICK 4
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $7,000
												</v-col>
											</v-row>
											<v-row class='prize-item'>
												<v-col class='prize-name text-uppercase' cols='6'>
													PICK 5
												</v-col>
												<v-col class='prize-amount text-right d-flex align-center justify-end' cols='6'>
													1 x $30,000
												</v-col>
											</v-row>
										</v-container>
									</v-card>
								</template>
							</card-presenter>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="12" class="text-center mt-2">
			<span id="webpage">
				caribbeanpicks.com
			</span>
		</v-col>
	</v-row>
</template>

<script>
import Countdown from '@homepage/components/Countdown.vue';
import CurrentDateAndTimeDisplay from '@homepage/components/CurrentDateAndTimeDisplay.vue';
import {generateImageMapFor} from '@homepage/helpers/image.js';
import CardPresenter from '@homepage/components/CardPresenter.vue';
import PrizesList from '@homepage/components/PrizesList.vue';
import ResultDisplay from "@homepage/components/CaribbeanPickResultDisplay.vue";
import ComplexResultDisplay from '@homepage/components/CaribbeanPickComplexResultDisplay.vue'
import HotColdNumbers from '@homepage/components/HotColdNumbers.vue';

function randomIntFromInterval(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min)
}

export default {
	name: 'CaribbeanPickBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	created() {
		const numbersToGenerate = 12;
		const numbers = [];
		do {
			const number = randomIntFromInterval(0, 99);
			if (!numbers.includes(number)) {
				numbers.push(number);
			}
		} while (numbers.length < numbersToGenerate);

		this.hotNumbers.first = numbers.slice(0, 2);
		this.hotNumbers.second = numbers.slice(2, 4);
		this.hotNumbers.third = numbers.slice(4, 6);
		this.coldNumbers.first = numbers.slice(6, 8);
		this.coldNumbers.second = numbers.slice(8, 10);
		this.coldNumbers.third = numbers.slice(10, 12);
	},
	data() {
		return {
			timeToShowResultsPage: 15000,
			timeToShowPrizesPage: 8000,
			timeToShowEachLotteryResultPage: 10000,
			lotteryEntriesPerPage: 3,
			hotNumbers: {
				first: [],
				second: [],
				third: []
			},
			coldNumbers: {
				first: [],
				second: [],
				third: []
			}
		};
	},
	components: {
		HotColdNumbers,
		ComplexResultDisplay,
		ResultDisplay,
		PrizesList,
		CurrentDateAndTimeDisplay,
		Countdown,
		CardPresenter
	},
	beforeCreate() {
		this.$emit('change-style', {backgroundImage: require('@/assets/img/caribbeanPick/background.webp')});
	}
};
</script>

<style scoped lang="scss">
$card-background: rgba(24, 47, 105, 0.7);

@font-face {
	font-family: "Made Tommy Outline";
	src: url("../../../../public/fonts/MADE TOMMY Bold Outline.otf");
}

@font-face {
	font-family: "Made Tommy Bold";
	src: url("../../../../public/fonts/MADE TOMMY ExtraBold.otf");
}

* {
	font-family: "Made Tommy Bold", "Liberation Sans Narrow", serif;
	color: white;
}

#description {
	font-size: 25px;
	text-transform: uppercase;
	background: linear-gradient(to right, #754823, #ff7300);
	letter-spacing: 3px;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

#countdown {
	background-image: url("../../../assets/img/caribbeanPick/clock_pattern.png");
	background-size: contain;
	background-repeat: repeat;
}

.v-card {
	background-color: $card-background !important;
	box-shadow: 8px 6px 20px 0 #07000080 !important;
}

#time-left {
	font-weight: 700;
	font-size: 3.5rem;
	text-align: center;
}

.prize-name {
	font-weight: 800;
	font-size: 150%;
}

.prize-amount {
	font-weight: 800;
	font-size: 135%;
	letter-spacing: 3px;
}

.prize-item {
	border-radius: 15px;
	margin: 5px 0;
}

.prize-item .col {
	padding: 4px 12px;
}

.prize-item:nth-child(odd), ::v-deep .sortition-result:nth-child(odd) > .row {
	background-color: rgba(232, 229, 229, 0.3);
}

.prize-item:nth-child(even), ::v-deep .sortition-result:nth-child(even) > .row {
	background-color: opacify($card-background, 0.1);
}

#webpage {
	letter-spacing: 1em;
	text-transform: uppercase;
	font-size: 120%;
	font-weight: bold;
}

.text-spread {
	letter-spacing: 10px !important;
}

#draws span {
	font-size: 135%;
}
</style>
